/**
 * App-scoped chat singletons. Mirrors mobile's `@lazySingleton`
 * providers: one conversation store feeds the list screen and the nav
 * badge, and one session owns the socket for the whole login.
 */
import { ChatHubClient } from './chatHub'
import { ChatSession } from './chatSession'
import { ChatConversationStore, defaultConversationStoreDeps } from './conversationStore'

export const chatListStore = new ChatConversationStore(defaultConversationStoreDeps())

let session: ChatSession | null = null

export function getChatSession(): ChatSession {
  if (!session) session = new ChatSession(new ChatHubClient())
  return session
}

/** Test-only: drop the session so the next caller builds a fresh one. */
export function resetChatSession(): void {
  session = null
}
